module.exports = __webpack_public_path__ + "static/media/tags.f1e6efb2.svg";